"use client"

import { Box, Typography } from "@mui/material"
import { APP_EDGE_DOCK_HEIGHT } from "@/components/layout/layout-constants"

export function AppFooter() {
  return (
    <Box
      sx={{
        minHeight: APP_EDGE_DOCK_HEIGHT,
        display: "flex",
        alignItems: "center",
        px: { xs: 2, md: 3 },
        py: 1.25,
        borderTop: "1px solid rgba(15,23,42,0.06)",
        color: "rgba(15,23,42,0.32)",
      }}
    >
      <Box>
        <Typography sx={{ fontSize: 10, lineHeight: 1.7 }}>
          Along · Pure One Operations
        </Typography>
        <Typography sx={{ fontSize: 10, lineHeight: 1.7, color: "rgba(15,23,42,0.26)" }}>
          项目代号：磐石 · 系统由 Via 协同驱动 · © 2026 PureOne Travel Inc.
        </Typography>
      </Box>
    </Box>
  )
}
